<template>
  <div class="container-fluid py-4">
    <h4 class="h4 font-weight-bold text-left text-capitalize">{{titleCase(hotel.name)}} —  Floor {{ floor.code }} Rooms</h4>
    <hr />
    <div class="box-container">
      <div v-for="room in rooms_beds" class="boxes">
        <div class="border" style="height: 160px; width: auto; overflow: hidden;" v-bind:class="scrollableRoom(room.beds)">
          <div class="beds-container">
            <div class="beds" v-for="(bed, index) in room.beds"
                 v-bind:class="checkOccupied(bed.isOccupied)" @click="viewProfile(bed)">
              <div>
                {{ index + 1 }}
              </div>
            </div>
          </div>
        </div>
        <h6 class="h6 tnkc-primary-text pt-2">Room: <span>{{room.roomCode}}</span></h6>
        <p>Status:
          <span> {{room.countBedOccupied}} / {{room.beds.length}}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {appMixins} from '@/mixins/app.mixins';
import {mapActions, mapGetters} from 'vuex';

export default {
  name: "Floor",
  props: ['floor_id','hotel_id'],
  mixins:[appMixins],
  methods: {
    ...mapActions( ['viewHotel','getFloorRooms','getAllRoomsWithBeds'] ),
    viewProfile(obj) {
      let crew_id = obj.crew_id ? obj.crew_id : null;
      let guest_id = obj.guest_id ? obj.guest_id : null;

      if(crew_id != null && obj.isOccupied){
        this.$router.push({name: 'CrewProfile', params: {id: crew_id}});
      }else if(guest_id != null && obj.isOccupied){
        this.$router.push({name: 'GuestProfile', params: {guest_id: guest_id}});
      }
    },
    async hotelFloorDetails(){
      this.viewHotel(this.hotel_id).then((res)=>{
        if (res === true){
          return this.hotel;
        }
      });
      this.getFloorRooms({id: this.floor_id}).then((res)=>{
        if (res === true){
          return this.floor;
        }
      });
      this.getAllRoomsWithBeds({floor_id: this.floor_id}).then((res)=>{
        if (res === true){
          return this.floor;
        }
      });
    },
    checkOccupied(bedStatus){
      return bedStatus ? 'tnkc-danger' : '';
    },
    scrollableRoom(obj){
      if(obj.length > 6){
        return 'scrollableRoom';
      }
    },
  },

  created() {
    this.hotelFloorDetails();
  },

  computed: {
    ...mapGetters( ['hotel','floor','rooms_beds'] ),
  },

  watch: {
    floor_id: function(prop_floorId){
      this.getFloorRooms({id: prop_floorId});
      this.getAllRoomsWithBeds({floor_id: prop_floorId});
    },
    hotel_id: function(prop_hotelID){
      this.viewHotel(prop_hotelID);
    }
  }
}
</script>

<style scoped>
.tnkc-danger {
  background-color: #ff9d8a;
}

.scrollableRoom{
  overflow-y: scroll !important;
}


</style>
